module.exports = __webpack_public_path__ + "img/fcLOgo.e93c9eae.svg";